import styled from 'styled-components';

export const ThumbnailTrigger = styled.label`
	display: inline-block;
	position: relative;
	cursor: pointer;
	line-height: 0;

	&:hover .thumbnail-upload-overlay {
		opacity: 1;
	}
`;

export const ThumbnailUploadOverlay = styled.div`
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.35);
	color: white;
	opacity: 0;
	pointer-events: none;
	transition: opacity 120ms ease-in-out;
`;

export const ThumbnailActions = styled.div`
	display: inline-block;
	width: 100%;
	vertical-align: top;
`;

export const HiddenThumbnailInput = styled.input`
	opacity: 0;
	position: absolute;
	width: 0;
	height: 0;
	pointer-events: none;
`;
